module.exports = __webpack_public_path__ + "img/ic_peer_feedback.1b4f1573.png";